module.exports = __webpack_public_path__ + "static/Dafodil-03-6261a9d0a994da8db2f3920811e421b6.png";